import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { knuthShuffle } from '@utils/common';
import { baseTaskSchema } from '../schema.base.js';
import { transparentImageOnImageDropzoneInput } from './input.dropzone.js';

const tileSchema = z.object({
  type: z.literal("Image"),
  title: z.string(),
  src: z.string(),
  altText: z.string().nullish().default(null),
  correctAnswer: z.number().nullable().default(null)
});
const placeTransparentImagesOnImageTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("PlaceItems"),
  answerType: z.literal("TransparentImagesOnImage"),
  background: z.string(),
  backgroundAltText: z.string().nullish().default(null),
  backgroundLongDescription: z.string().nullish().default(null).transform(it => it ? xml2ast(it, allHtmlParsers, "text/html") : null),
  items: z.array(tileSchema),
  dropzones: z.array(transparentImageOnImageDropzoneInput.schema),
  settings: z.object({
    visibleDropzones: z.boolean().default(true)
  }).default({
    visibleDropzones: true
  })
}).transform(({
  dropzones,
  items,
  background,
  ...rest
}) => {
  const indicesForDedupedDropzones = new Map();
  const dedupedDropzones = dropzones.filter((it, index) => {
    const key = getKeyForDropzone(it);
    const indicesForDropzone = indicesForDedupedDropzones.get(key) ?? [];
    const hasEncounteredBefore = indicesForDropzone.length > 0;
    indicesForDropzone.push(index);
    indicesForDedupedDropzones.set(key, indicesForDropzone);
    return !hasEncounteredBefore;
  });
  const tiles = items.map((it, index) => ({
    ...it,
    id: `${rest.id}-${index}`,
    // NB: TileKeys may be identical across multiple tiles in case they
    // contain exactly the same content. This is intentional as all such tiles
    // should be considered the same during validation.
    tileKey: `${it.title}-${it.src}`
  }));
  return {
    ...rest,
    backgroundImageSrc: background,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __orderedTiles: tiles.map(({
      correctAnswer,
      ...rest
    }) => rest),
    tiles: knuthShuffle(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    structuredClone(tiles.map(({
      correctAnswer,
      ...rest
    }) => rest))),
    content: dedupedDropzones.map((raw, index) => transparentImageOnImageDropzoneInput.postprocessSchemaInput(raw, {
      index,
      indicesForDropzone: indicesForDedupedDropzones.get(getKeyForDropzone(raw)) ?? [],
      taskId: rest.id,
      tiles
    }))
  };
});
function getKeyForDropzone(dropzone) {
  return JSON.stringify(dropzone);
}

export { placeTransparentImagesOnImageTaskSchema };
//# sourceMappingURL=_schema.js.map
